import React, { useState } from 'react';
import { Modal, TextField, Select, MenuItem, Button } from '@mui/material';
import { editUser } from '../../api/axios';
import { useTheme } from '@mui/material/styles';

const EditUserModal = ({ open, setOpen, editingUser, setEditingUser, setUsers, users }) => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [newPass, setNewPass] = useState('');
  const [confirmNewPass, setConfirmNewPass] = useState('');
  const theme = useTheme();

  console.log(editingUser);

  const handleUpdate = async () => {
    if (newPass && newPass !== confirmNewPass) {
      setErrorMessage('Lozinke se ne poklapaju.');
      return;
    }

    try {
      setLoading(true);
      setErrorMessage('');

      const accessToken = localStorage.getItem("accessToken");

      const params = new URLSearchParams();
      params.append('id', editingUser.id);
      params.append('username', editingUser.username);
      if (editingUser.lozinka) params.append('old_pass', editingUser.password);
      if (newPass) params.append('new_pass', newPass);
      params.append('email', editingUser.email);
      params.append('ac_lvl', editingUser.access_level);
      params.append('accessToken', accessToken);

      const response = await editUser(params);

      const { success, message } = response.data;
      if (success) {
        const updatedUsers = users.map(user =>
          user.id === editingUser.id ? { ...user, ...editingUser } : user
        );
        setUsers(updatedUsers);
        setOpen(false);
      } else {
        setErrorMessage(message || 'Error during update.');
      }
    } catch (error) {
      console.error('Error updating user:', error);
      if (error.response && error.response.status === 401) {
        setErrorMessage('Invalid token or token not provided.');
      } else if (error.response && error.response.status === 400) {
        setErrorMessage('Error updating user or missing ID parameter.');
      } else if (error.response && error.response.status === 405) {
        setErrorMessage('Method not allowed. Expected POST request.');
      } else {
        setErrorMessage('An unexpected error occurred.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    setEditingUser(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="edit-user-modal"
      aria-describedby="modal-to-edit-user"
    >
      <div
        style={{
          padding: 20,
          margin: '10% auto',
          width: '400px',
          backgroundColor: theme.palette.background.default,
          color: theme.palette.text.primary,
        }}
      >
        <h2>Edit User</h2>
        <TextField
          label="Username"
          value={editingUser.username || ''}
          onChange={(e) => handleChange('username', e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Current Password"
          type="password"
          value={editingUser.password || ''}
          onChange={(e) => handleChange('password', e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="New Password"
          type="password"
          value={newPass}
          onChange={(e) => setNewPass(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Confirm New Password"
          type="password"
          value={confirmNewPass}
          onChange={(e) => setConfirmNewPass(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Email"
          value={editingUser.email || ''}
          onChange={(e) => handleChange('email', e.target.value)}
          fullWidth
          margin="normal"
        />
        <Select
          label="Access Level"
          value={editingUser.access_level || ''}
          onChange={(e) => handleChange('access_level', e.target.value)}
          fullWidth
          margin="normal"
        >
          <MenuItem value="korisnik">Korisnik</MenuItem>
          <MenuItem value="administrator">Administrator</MenuItem>
        </Select>
        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}

        <div style={{ display: 'flex', marginTop: '10px' }}>
          <Button
            onClick={handleUpdate}
            variant="contained"
            color="primary"
            disabled={loading}
            style={{ flex: 1, marginRight: '5px' }}
          >
            {loading ? 'Updating...' : 'Update'}
          </Button>
          <Button
            onClick={() => setOpen(false)}
            variant="outlined"
            style={{ flex: 1, marginLeft: '5px' }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default EditUserModal;
